import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";

import ActionPromptSlice from "../features/actionPromptSlice";
import AddSearchApiSlice from "../features/addSearchApiSlice";
import AuthenticationSliceDdc from "../features/authenticationSliceDdc";
import ComplianceConsentSlice from "../features/complianceConsentSlice";
import IoBaseApiSlice from "../features/io/ioBaseApiSlice";
import NetlifyApiSlice from "../features/netlifyApiSlice";
import NotificationSlice from "../features/notificationSlice";
import RegistrationSlice from "../features/registrationSlice";
import SspRegistrationSlice from "../features/sspRegistrationSlice";
import SspSlice from "../features/sspSlice";
import TrackingSlice from "../features/trackingSlice";
import UpdateAddressSlice from "../features/updateAddressSlice";

const rootReducer = combineReducers({
  [IoBaseApiSlice.reducerPath]: IoBaseApiSlice.reducer,
  [NetlifyApiSlice.reducerPath]: NetlifyApiSlice.reducer,
  [AddSearchApiSlice.reducerPath]: AddSearchApiSlice.reducer,
  actionPrompt: persistReducer({
    key: "dkms-ssp-action-prompt",
    storage,
  }, ActionPromptSlice),
  authenticationDdc: persistReducer({
    key: "dkms-ddc",
    storage,
  }, AuthenticationSliceDdc),
  complianceConsent: ComplianceConsentSlice,
  notification: persistReducer({
    key: "dkms-n",
    storage,
  }, NotificationSlice),
  registration: persistReducer({
    key: "dkms-reg",
    storage,
  }, RegistrationSlice),
  ssp: persistReducer({
    key: "dkms-ssp",
    storage: storageSession,
  }, SspSlice),
  sspRegistration: persistReducer({
    key: "dkms-ssp-registration",
    storage: storageSession,
  }, SspRegistrationSlice),
  tracking: persistReducer({
    key: "dkms-t",
    storage: storageSession,
  }, TrackingSlice),
  updateAddress: UpdateAddressSlice,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
